<template>
	<div>
		<div class="inner-headline-wrapper">
			<div class="inner-headline-title">{{ getStateWithParam(menuItemToPresent.name) }}</div>
			<img class="subnav-img" :src="menuItemToPresent.image" alt />
		</div>
	</div>
</template>

<script>
export default {
	props: {
		menuItemToPresent: {
			type: Object,
			required: true
		}
	},
	methods: {
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		}
	}
};
</script>
<style  lang="scss" scoped >
.inner-headline-wrapper {
	display: flex;
	justify-content: space-between;
	height: 80px;
	.inner-headline-title {
		font-size: 24px;
		font-weight: 800;
		color: white;
		letter-spacing: 0.8px;
		line-height: 1.1;
	}
	.subnav-img {
		width: auto;
		height: 100%;
	}
}
</style>
